'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var _babelHelpers = require('./_babelHelpers-48e7a7f7.js');
var settings = require('./settings-9ee2f03f.js');

var _templateObject = _babelHelpers.taggedTemplateLiteral(["\n  border: 0px;\n  border-top: solid ", "\n    ", ";\n  margin: ", ";\n  @media (max-width: 991px) {\n    ", ";\n  }\n"], ["\n  border: 0px;\n  border-top: solid ", "\n    ", ";\n  margin: ", ";\n  @media (max-width: 991px) {\n    ", ";\n  }\n"]);

var StyledHr = styled__default.hr(_templateObject, function (props) {
  return props.thickness ? props.thickness : "1px";
}, function (props) {
  return props.color ? props.color : settings.COLOR.lineGray;
}, function (props) {
  return props.margin ? props.margin : "0px 0px";
}, function (props) {
  return props.mMargin && "margin:" + props.mMargin;
});

/**
 * The Horizontal Line component
 * @param {String} thickness the thickness of the line
 * @param {String} color the color of the line
 */

var Hr = function (_Component) {
  _babelHelpers.inherits(Hr, _Component);

  function Hr(props) {
    _babelHelpers.classCallCheck(this, Hr);

    var _this = _babelHelpers.possibleConstructorReturn(this, (Hr.__proto__ || Object.getPrototypeOf(Hr)).call(this, props));

    _this.state = {};
    return _this;
  }

  _babelHelpers.createClass(Hr, [{
    key: "render",
    value: function render() {
      var rest = _babelHelpers.objectWithoutProperties(this.props, []);

      return React__default.createElement(StyledHr, rest);
    }
  }]);
  return Hr;
}(React.Component);

Hr.propTypes = {
  /** thickness of text */
  thickness: PropTypes.string,
  /** color of text */
  color: PropTypes.string,
  /** panel margin */
  margin: PropTypes.string
};
Hr.__docgenInfo = {
  "description": "The Horizontal Line component\n@param {String} thickness the thickness of the line\n@param {String} color the color of the line",
  "methods": [],
  "displayName": "Hr",
  "props": {
    "thickness": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "thickness of text"
    },
    "color": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "color of text"
    },
    "margin": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "panel margin"
    }
  }
};

exports.StyledHr = StyledHr;
exports.default = Hr;
//# sourceMappingURL=hr.js.map
